module.exports = __webpack_public_path__ + "img/icon_wancheng@2x.d9ef7bd4.png";